export const isBottomPositioned = (container: HTMLElement): boolean => container.getBoundingClientRect().bottom + 10 >= window.innerHeight;
